// SEQ-169 claim timing: a view of the shared Supabase client typed for the
// tables and columns the claim timing migration adds.
//
// This is the same client instance and therefore the same session, cookies and
// RLS context. Only the schema type differs, because database.types.ts is
// generated from the live schema and cannot describe an unapplied migration.
//
// Use it ONLY for claims_project_config, claims_project_config_history and the
// two claims_reports timing columns. Everything else goes through the plain
// client, which has the full generated schema.
//
// REMOVE once database.types.ts is regenerated: replace every claimTimingDb call
// with the plain supabase client and delete this file together with
// src/types/claimTiming.types.ts.

import type { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "./supabase";
import type { ClaimTimingDatabase } from "../types/claimTiming.types";

export const claimTimingDb = supabase as unknown as SupabaseClient<
  ClaimTimingDatabase
>;
